// extracted by mini-css-extract-plugin
module.exports = {"section":"section-3OOFy","timedEntry":"timedEntry-wnZMY","heading":"heading-3AIZs"};